/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Readonly Assignment Name Field
 *
 * @file ReadonlyAssignmentNameField.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';

const ReadonlyAssignmentNameField = ({
  classes,
  label,
  value,
  id,
  disabled = false,
  isLoading = false
}) => (
  <div className={classes.assignmentNameField}>
    <label htmlFor={id} className={classes.assignmentNameLabel}>
      {label}
    </label>
    <div className={classes.assignmentNameInputWrap}>
      <input
        id={id}
        type="text"
        value={value}
        readOnly
        tabIndex={-1}
        className={disabled ? classes.readonlyInputDisabled : classes.readonlyInput}
        aria-readonly="true"
        aria-busy={isLoading}
      />
      {isLoading && (
        <CircularProgress
          size={20}
          className={classes.assignmentNameLoader}
          aria-hidden="true"
        />
      )}
    </div>
  </div>
);

ReadonlyAssignmentNameField.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool
};

ReadonlyAssignmentNameField.defaultProps = {
  disabled: false,
  isLoading: false
};

export default ReadonlyAssignmentNameField;
